import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const QuestionIcon = ({
  title = 'Question',
  viewBox = '0 0 24 24',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.116 4.958C17.057 2.298 14.783.168 12 .168c-2.82 0-5.118 2.186-5.118 4.896v1.623H4.235C3.553 6.688 3 7.226 3 7.889V22.3c0 .663.553 1.201 1.235 1.201h15.53c.682 0 1.235-.538 1.235-1.2V7.887c0-.663-.553-1.2-1.235-1.2h-2.647V5.063l-.002-.106ZM14.647 9.09v1.887l.002.066c.035.632.574 1.135 1.233 1.135.682 0 1.236-.538 1.236-1.201V9.09h1.412V21.1H5.47V9.09h1.411v1.887l.002.066c.035.632.574 1.135 1.234 1.135.682 0 1.235-.538 1.235-1.201V9.09h5.294Zm0-2.402V5.063c0-1.372-1.18-2.494-2.647-2.494-1.438 0-2.6 1.078-2.646 2.412l-.001.082v1.623h5.294Z"
    />
  </CreateIconComponent>
);

export default QuestionIcon;
